import * as yup from "yup";


export const sendEmailSchema = yup.object().shape({
  to: yup.string().required().label("To Address"),
  subject: yup.string().required().label("Subject"),
});
